export default {
  graphqlUrl: process.env.REACT_APP_API_URL,
}
